import styled from "styled-components";

export const SidebarTrigger = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s all;
`;
